<template>
  <a-spin
        tip="Your document is being processed, do not leave this page!"
        :spinning="loading.page"
    >
    <a-card>
      <span slot="title"
        ><a-tag color="green">{{ mode == "Create" ? "Create" : "Edit" }}</a-tag>
        Refund Payment</span
      >
      <a-steps :current="current" status="process">
        <a-step title="Information" />
        <a-step title="Value Refund" />
        <a-step title="Detail" v-if="stepRuleDtl"/>
      </a-steps>

      <div
        class="steps-content flex-1"
        :class="
          steps[current].content == 'Detail' ? 'padding-remove border-none' : ''
        "
      >
        <component
          class="flex-1"
          :is="steps[current].content"
          :ref="stepRef"
          v-bind="stepProps"
        ></component>
      </div>

      <template class="ant-card-actions" slot="actions">
        <div class="steps-action">
          <a-button v-if="stepRuleDtl ? (current < steps.length - 1) : (current < steps.length - 2)" type="primary" @click="next"
            >Next</a-button
          >
          <a-button
            v-if="stepRuleDtl ? (current == steps.length - 1) : (current == steps.length - 2)"
            type="primary"
            :loading="loading.submit"
            @click="validate"
            >Save</a-button
          >
          <a-button v-if="current > 0" @click="prev">Previous</a-button>
        </div>
      </template>

    </a-card>
  </a-spin>
</template>

<script>
import { mapGetters } from "vuex";
import Information from "./steps/Information.vue";
import Details from "./steps/Detail.vue";
import ValueRefund from "./steps/ValueRefund.vue";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import moment from "moment";
import nanoid from "nanoid";
export default {
  name: "create-refundPayment",
  components: {
    Information,
    ValueRefund,
    Details,
  },
  mixins: [CurrencyFormat,GlobalMethod],
  data() {
    return {
      current: 0,
      mode: "Create",
      steps: [
        {
          title: "Information",
          content: "Information",
        },
        {
          title: "ValueRefund",
          content: "ValueRefund",
        },
        {
          title: "Detail",
          content: "Details",
        },
      ],
      dataProcessed: {
        information: undefined,
        detilPO: undefined,
        push: undefined,
      },
      loading:{
        page: false,
        submit:false,
      },
      isModifiedDtl: {
        id_transaksi:""
      },
      temp : {
        currencyList: [],
        accountToList : [],
      },
      stepRuleDtl : true,
    }
  },
  computed: {
    ...mapGetters([
      "getAuth",
    ]),
    stepRef: function () {
      let result = null;
      if (this.steps[this.current].content === "Information") {
        result = "refInformation";
      } else if (this.steps[this.current].content === "ValueRefund") {
        result = "refValueRefund";
      } else if (this.steps[this.current].content === "Details") {
        result = "refDetail";
      }
      return result;
    },
    stepProps: function () {
      let result = null;
      if (this.steps[this.current].content === "Information") {
        result = {
          dataProcessed: this.dataProcessed,
          mode: this.mode,
        };
      } else if (this.steps[this.current].content === "ValueRefund") {
        result = {
          dataProcessed: this.dataProcessed,
          detilPO: this.dataProcessed.detilPO,
          mode: this.mode,
          isModifiedDtl: this.isModifiedDtl,
          currencyList: this.temp.currencyList,
          accountToListOri: this.temp.accountToList,
        };
      } else if (this.steps[this.current].content === "Details") {
        result = {
          dataProcessed: this.dataProcessed,
          detilPO: this.dataProcessed.detilPO,
          mode: this.mode,
          isModifiedDtl: this.isModifiedDtl,
        };
      }
      return result;
    },
  },
  mounted(){
    Event.$on("rp_infoData", this.valueFromChild);
    Event.$on("rp_infoDataB", this.backvalueFromChild);
    Event.$on("setDetilPOpr", this.setdetilPO);
    Event.$on("confirmMessageReturn", this.submit);
    Event.$on("setstepRuleDtl", this.setstepRuleDtl);
  },
  beforeDestroy() {
    Event.$off("rp_infoData", this.valueFromChild);
    Event.$off("rp_infoDataB", this.backvalueFromChild);
    Event.$off("setDetilPOpr", this.setdetilPO);
    Event.$off("confirmMessageReturn", this.submit);
    Event.$off("setstepRuleDtl", this.setstepRuleDtl);
  },
  methods:{
    next() {
      if (this.steps[this.current].content === "Information") {
        this.$refs.refInformation.handleRef();
      } else if (this.steps[this.current].content === "ValueRefund") {
        this.$refs.refValueRefund.handleRef();
      } 
    },
    prev() {
      // if (this.steps[this.current].content === "ValueRefund") {
      //   this.$refs.refValueRefund.backhandleRef();
      // }else{
        this.current--;
      // }
    },
    valueFromChild(value) {
      if (this.steps[this.current].content === "Information") {
        if (this.mode === "Create") {
          this.dataProcessed.information = JSON.parse(
            JSON.stringify(value.informasi)
          );
          this.dataProcessed.push = value.push;
        }
        this.temp.currencyList =  value.currencyList;
        this.temp.accountToList = value.accountToList;
        this.current++;
      } else if(this.steps[this.current].content === "ValueRefund"){
        this.dataProcessed.value_refund = value.value_refund;
        if(this.stepRuleDtl)
          this.current++;
      }
    },
    backvalueFromChild(value) {
      if(this.steps[this.current].content === "ValueRefund"){
        this.dataProcessed.value_refund = value.value_refund;
        this.current--;
      }
    },
    setdetilPO(val){
      this.dataProcessed.detilPO = val
    },
    validate(){
      if(!this.stepRuleDtl){
        this.$refs.refValueRefund.handleRef();
      }
      
      // let valrefund =  this.dataProcessed.value_refund.value_refund*this.dataProcessed.value_refund.kurs;
      // //console.log(valrefund,(this.dataProcessed.information.value).toFixed(2))
      // if(valrefund>this.dataProcessed.information.nopowo.value_ap){
      //   this.displayMessageValue(
      //     "error-other",
      //     "Total Value Refund must be less than value AP or value Other Outcome ("+this.formatCurrency(this.dataProcessed.information.currency,
      //       this.dataProcessed.information.nopowo.value_ap)+")!"
      //   );
      // }else{
        this.confirmMessage("confirm-save");
      // }
    },
    submit() {
        this.loading.page = true;

        let data = new FormData();
        data.append("tlc", this.getAuth.username);
        data.append("type_of_transaction",this.dataProcessed.information.jns_transaksi);
        data.append("no_po_wo",this.dataProcessed.information.nopowo.id_transaksi);
        data.append("description", this.dataProcessed.information.description);

        this.dataProcessed.push.forEach((item) => {
          data.append("document_name[]", item.document_name);
          data.append("upload_file_support[]", item.file);
        });

        data.append("receive_from", this.dataProcessed.value_refund.receive_from);
        data.append("kurs", this.dataProcessed.value_refund.kurs);
        data.append("currency_from", this.dataProcessed.value_refund.currency_from);
        data.append("account_from", this.dataProcessed.value_refund.account_from);
        data.append("value_refund", this.dataProcessed.value_refund.value_refund);
        data.append("date_transfer", this.dataProcessed.value_refund.date_transfer);
        data.append("value_cost_refund", this.dataProcessed.value_refund.value_cost_refund);
        data.append("account_to", this.dataProcessed.value_refund.account_to);
        data.append("currency_to", this.dataProcessed.value_refund.currency_to);
        data.append("value_receive", this.dataProcessed.value_refund.value_receive);
        data.append("file_support", this.dataProcessed.value_refund.evidence_transfer.file);

        if(this.stepRuleDtl){
          this.dataProcessed.detilPO.forEach((item) => {
            data.append("id_dtl[]", this.dataProcessed.information.jns_transaksi=='po' ? item.id_po_dtl : item.id_wo_dtl);
            data.append("is_item[]", item.is_item);
            data.append("used_for[]", item.used_for ? item.used_for : "0");
            data.append("id_pp_dtl[]", item.selectedPPdtl);
            data.append("item_pn[]", item.item_pn ? item.item_pn : "");
            data.append("nama_barang[]", item.nama_barang);
            data.append("jumlah[]", item.jumlah ? item.jumlah : 0);
            data.append("hargaTotal[]", item.hargaTotal);
            data.append("satuan[]", item.satuan ? item.satuan :"");
            data.append("unit_price[]", item.cur_type);//
            data.append("harga[]", item.harga);
            data.append("type_item[]", item.type_item);
          });
        }

        
        this.asyncAxiosPost("payment_refund", "formdata", this.getAuth, data)
        .then((response) => {
          console.log(response)
          this.displayMessage("success-save");
          this.loading.page = false;

          this.$router.go(-1);
        })
        .catch((err) => {
          console.log(err);
          this.loading.page = false;
        });
    },
    setstepRuleDtl(val){
      this.stepRuleDtl = val;
    }
  }
}
</script>